<template>
  <footer class="footer" :class="{ '-grey': grey }">
    <div class="footer__icons">
      <!-- <div class="footer__icons__box" v-if="isCorporate">
        <icon-support />
        <span class="footer__icons__box__text" @click="goHelpPage()"
          >Yardımcı Olalım </span
        >
      </div> -->
      <div class="footer__icons__box">
        <icon-phone />
        <span class="footer__icons__box__text" v-if="isCorporate"
          >0850 622 6 623</span
        >
        <span class="footer__icons__box__text" v-else>0850 226 0 123</span>
      </div>
    </div>
    <!-- <div class="footer__version">v 1.4</div>
    <div class="footer__logos">
      <img src="@/assets/img/symantec.png" />
    </div> -->
  </footer>
</template>

<script>
export default {
  props: {
    grey: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isCorporate: function () {
      return this.$store.getters.getBankType == "corporate";
    },
  },
  methods: {
    goHelpPage: function () {
      this.$router.push({ name: "corporateHelp" });
    },
  },
};
</script>